// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".contact-column{padding-top:0}.contact-column--short-display{padding-top:10px}.contact-column__name{margin:0}.contact-column__name--short-display{margin:10px 0 20px}.contact-column .county{text-transform:capitalize}", ""]);
// Exports
module.exports = exports;
